import { ResponseStructure } from '@iq-central-front-end/share';

import { Subscription } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { CourseService } from '../../../_services/course.service';
import { GlobalService } from '../../../_services/global.service';
import { Router } from '@angular/router';

@Component({
  selector: 'iq-central-front-end-choose-date',
  templateUrl: './choose-date.component.html',
  styleUrls: ['./choose-date.component.scss'],
})
export class ChooseDateComponent implements OnInit, OnDestroy {
  dueDate;
  finalData;
  today: Date = new Date();
  sub: Subscription = new Subscription();
  constructor(
    private fb: FormBuilder,
    private _course: CourseService,
    private _global: GlobalService,
    private _router: Router
  ) {
    this.getData();
  }

  ngOnInit(): void {}
  onDueDateChange(date) {
    console.log(date);
    this.dueDate = date;
  }

  getData() {
    this._course.getCsDTOData().subscribe((res) => {
      this.finalData = res;
    });
  }
  assign() {
    this._global.showSpinner();
    console.log(this.dueDate);
    this._course.setDateData({
      dueDate: this.dueDate,
    });
    console.log(this.finalData);
    if (this.finalData['participantType'] === 'individuals') {
      this.sub.add(
        this._course.assignCourseToStaffs(this.finalData).subscribe({
          next: (res: ResponseStructure) => {
            this._global.hideSpinner();
            this._course.reset();

            this._router.navigate(['assignCourse/confirmation']);
          },
        })
      );
    } else if (this.finalData['participantType'] === 'departments') {
      this.sub.add(
        this._course.assignCourseToDepartments(this.finalData).subscribe({
          next: (res: ResponseStructure) => {
            this._global.hideSpinner();
            this._course.reset();
            this._router.navigate(['assignCourse/confirmation']);
          },
        })
      );
    } else if (this.finalData['participantType'] === 'divisions') {
      this.sub.add(
        this._course.assignCourseToDivisions(this.finalData).subscribe({
          next: (res: ResponseStructure) => {
            this._global.hideSpinner();
            this._course.reset();
            this._router.navigate(['assignCourse/confirmation']);
          },
        })
      );
    } else if (this.finalData['participantType'] === 'units') {
      this.sub.add(
        this._course.assignCourseToUnits(this.finalData).subscribe({
          next: (res: ResponseStructure) => {
            this._global.hideSpinner();
            this._course.reset();
            this._router.navigate(['assignCourse/confirmation']);
          },
        })
      );
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
